var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.3765 16 16 12.3686 16 8C16 3.62353 12.3686 0 7.99216 0C3.62353 0 0 3.62353 0 8C0 12.3686 3.63137 16 8 16ZM6 8.25882C6 5.70196 6.65098 3.15294 7.86667 1.33333C7.90588 1.33333 7.95294 1.33333 7.99216 1.33333C11.6078 1.33333 14.5255 4.16471 14.6588 7.75686C12.8392 8.98039 10.2824 9.63137 7.71765 9.63137C7.16078 9.63137 6.60392 9.6 6.0549 9.53726C6.01569 9.11373 6 8.68235 6 8.25882ZM4.7451 8.25882C4.7451 8.61176 4.75294 8.96471 4.78431 9.3098C3.49804 9.01961 2.30588 8.52549 1.34118 7.84314C1.41176 4.76863 3.52157 2.22745 6.38431 1.52157C5.3098 3.40392 4.7451 5.82745 4.7451 8.25882ZM8 14.6667C7.93725 14.6667 7.87451 14.6667 7.81176 14.6667C7.05098 13.6 6.52549 12.2588 6.24314 10.8157C6.72941 10.8627 7.22353 10.8863 7.71765 10.8863C10.1961 10.8863 12.6745 10.298 14.5647 9.17647C14.0157 12.3059 11.2941 14.6667 8 14.6667ZM1.46667 9.30196C2.48627 9.92157 3.67059 10.3608 4.94118 10.6196C5.17647 12.0157 5.63137 13.3333 6.29804 14.4471C3.84314 13.8118 1.96078 11.8196 1.46667 9.30196Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjUnselected);
export default __webpack_public_path__ + "static/media/obj_unselected.41b760edf3640501a34c7fa33a381265.svg";
export { ForwardRef as ReactComponent };